import { toast } from 'react-toastify';
import appApi from '../../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../../api/errors/api-error-codes';
import globalSettingsStores from '../../../../../../../stores/settings-stores';

export const removeAbstractCourseFromProgram = async (
  abstractProgramId: number,
  abstractCourseId: number,
  setLoading: (courseId: number | null) => any,
) => {
  try {
    setLoading(abstractCourseId);
    const res = await appApi.deleteAbstractCourseFromAbstractProgram(
      abstractProgramId,
      abstractCourseId,
    );

    if (res.data.ok) {
      await globalSettingsStores.fetchSetting();
      toast.success('הקורס הוסר בהצלחה');
    } else if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    }

    setLoading(null);
  } catch (e) {
    console.error(
      `removeAbstractCourseFromProgram failed with abstractProgramId: ${abstractProgramId}, abstractCourseId: ${abstractCourseId}, error: ${e}`,
    );
    setLoading(null);
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
  }
};
